import {
  checkboxGroupSchema,
  checkboxGroupUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import {
  titleWithTag,
  form0781HeadingTag,
  mentalHealthSupportAlert,
} from '../content';
import {
  treatmentReceivedDescription,
  treatmentReceivedNoneLabel,
  treatmentReceivedTitle,
  validateProviders,
} from '../content/treatmentReceivedPage';
import {
  TREATMENT_RECEIVED_SUBTITLES,
  TREATMENT_RECEIVED_HINTS,
  TREATMENT_RECEIVED_VA,
  TREATMENT_RECEIVED_PRIVATE_MEDICAL,
} from '../constants';

export const uiSchema = {
  'ui:title': titleWithTag(treatmentReceivedTitle, form0781HeadingTag),
  'ui:description': treatmentReceivedDescription,
  treatmentReceivedVaProvider: checkboxGroupUI({
    title: TREATMENT_RECEIVED_SUBTITLES.va,
    labelHeaderLevel: '4',
    hint: TREATMENT_RECEIVED_HINTS.va,
    labels: {
      ...TREATMENT_RECEIVED_VA,
    },
    required: false,
  }),
  treatmentReceivedNonVaProvider: checkboxGroupUI({
    title: TREATMENT_RECEIVED_SUBTITLES.privateMedical,
    labelHeaderLevel: '4',
    hint: TREATMENT_RECEIVED_HINTS.privateMedical,
    labels: {
      ...TREATMENT_RECEIVED_PRIVATE_MEDICAL,
    },
    required: false,
  }),
  treatmentNoneCheckbox: checkboxGroupUI({
    title: TREATMENT_RECEIVED_SUBTITLES.none,
    labelHeaderLevel: '4',
    hint: TREATMENT_RECEIVED_HINTS.none,
    labels: {
      none: treatmentReceivedNoneLabel,
    },
    required: false,
  }),
  'view:mentalHealthSupportAlert': {
    'ui:description': mentalHealthSupportAlert,
  },
  'ui:validations': [validateProviders],
};

export const schema = {
  type: 'object',
  properties: {
    'view:conflictingResponseAlert': {
      type: 'object',
      properties: {},
    },
    treatmentReceivedVaProvider: checkboxGroupSchema(
      Object.keys(TREATMENT_RECEIVED_VA),
    ),
    treatmentReceivedNonVaProvider: checkboxGroupSchema(
      Object.keys(TREATMENT_RECEIVED_PRIVATE_MEDICAL),
    ),
    treatmentNoneCheckbox: checkboxGroupSchema(['none']),
    'view:mentalHealthSupportAlert': {
      type: 'object',
      properties: {},
    },
  },
};
